import { useState, useEffect } from 'react';

function useLocation() {
  const [location, setLocation] = useState({
    pathname: window ? window.location.pathname : "",
    search: window ? window.location.search : "",
    hash: window ? window.location.hash : "",
  });

  useEffect(() => {
    const handleLocationChange = () => {
      setLocation({
        pathname: window ? window.location.pathname : "",
        search: window ? window.location.search : "",
        hash: window ? window.location.hash : "",
      });
    };
    window.addEventListener("popstate", handleLocationChange);
    window.addEventListener("pushstate", handleLocationChange);
    window.addEventListener("replacestate", handleLocationChange);
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('pushstate', handleLocationChange);
      window.removeEventListener('replacestate', handleLocationChange);
    };
  }, []);

  return location;
};

export default useLocation;